import { render } from "./document-view.vue?vue&type=template&id=a81b7fda"
import script from "./document-view.vue?vue&type=script&lang=js"
export * from "./document-view.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__